import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { TableDatasource } from '@gamelearn/skeletor/models';
import { TranslateService } from '@ngx-translate/core';
import { StoreService } from 'core/services/store.service';

const NUM_ELEMENTS = [
  { key: 10, value: '10' },
  { key: 25, value: '25' },
  { key: 50, value: '50' },
  { key: 100, value: '100' },
  { key: 250, value: '250' }
];
// TODO this component maintains compatibility with admin tables and skeletor tables using the "skeletor" attribute, delete when not needed
@Component({
  selector: 'lms-items-count-selector',
  templateUrl: './items-count-selector.component.html',
  styleUrls: ['./items-count-selector.component.scss']
})
export class ItemsCountSelectorComponent implements OnInit, OnDestroy {
  @Input() listId: string;
  @Input() skeletor: boolean = false; // TODO flag to maintain compatibility true for skeletor table false for admin old ones
  public listSubscription: Subscription;
  private tableDatasource: TableDatasource;
  public items: any[];
  limit = 10;

  constructor(public translate: TranslateService) {}

  ngOnInit() {
    this.items = NUM_ELEMENTS;
    this.listSubscription = StoreService.get(this.listId).subscribe((data) => {
      if (this.skeletor) {
        this.tableDatasource = data;
      }
      if (data && data.limit && data.limit !== this.limit) {
        setTimeout(() => (this.limit = data.limit));
      }
    });
  }

  ngOnDestroy() {
    this.listSubscription.unsubscribe();
  }

  setItemsPerPage(limit) {
    if (this.skeletor) {
      if (limit !== this.tableDatasource.limit) {
        this.tableDatasource.refreshData({ limit, page: 1 });
        StoreService.update(this.listId, this.tableDatasource);
      }
    } else {
      StoreService.merge(this.listId, { limit, page: 1, active: true });
    }
  }
}
